/* src/app/system-view/main-dashboard/dashboard-filter-configurator/dashboard-filter-configurator.component.scss */
.container-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: var(--tem-space-4);
  min-height: 200px;
  position: relative;
}
.edit-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: auto;
}
.fc-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
  flex-shrink: 0;
}
.grid-view {
  flex: 1;
  min-height: 120px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  margin-top: var(--tem-space-2);
  margin-bottom: var(--tem-space-2);
  position: relative;
}
.fc-row {
  cursor: pointer;
}
form {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.fc-field {
  width: 100%;
  margin-bottom: var(--tem-space-2);
}
.fc-clear {
  cursor: pointer;
  color: var(--tem-muted);
}
.fc-clear:hover {
  color: var(--tem-danger);
}
.fc-list-textarea {
  min-height: 90px;
  resize: vertical;
}
.detail-item {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: var(--tem-space-3);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  overflow: auto;
}
.detail-item-tipo {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--tem-space-3);
}
.detail-item-tipo-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--tem-space-1);
  justify-content: center;
}
.detail-item-tipo-box-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: var(--tem-space-3);
}
.detail-item-tipo-box-listoption {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--tem-space-1);
}
.list-option-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--tem-space-1);
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=dashboard-filter-configurator.component.css.map */
